import React, { useEffect, useState } from 'react';
import './styles.scss';

const Text = (props) => {
    let [ load, setLoad ] = useState(false)

    useEffect(() => {
        if(!load) {
            setLoad(true);
        }
    }, [load])

    if(load && props.onclickItemID) {
        let click = document.getElementById(props.onclickItemID);
        if(click) {
            click.onclick = function(e) {
                props.setShowMore(true);
            }
        }
    }

    return (
        <div className={"text " + (props.class ? props.class : '') + " " +(props.margin ? "no-margin": "") + (props.smallMargin ? 'small-margin' : '')} >
            <p dangerouslySetInnerHTML={ {__html: props.text} } />
        </div>
    )
}

export default Text;